// sulfadimethoxine-chart.ts
import Alpine from 'alpinejs';
import "../store/email-capture"
import AppAnalytics from '../analytics/AppAnalytics';
import '../components/sulfadimethoxine-chart';

(window as typeof window & { Alpine: typeof Alpine }).Alpine = Alpine;

document.addEventListener('alpine:init', () => {
  Alpine.data('sulfadimethoxineChartPage', function() {
    return {
      init() {
        // Initialize any page-specific functionality here
        console.log('Sulfadimethoxine Chart Page initialized');

        // Track page view
        AppAnalytics.getPlausible()?.trackEvent('sulfadimethoxine_chart_page_view');
      }
    };
  });
});

Alpine.start();